import React from "react";
import styled from "styled-components";
import contactusVideo from "../../../assets/images/contactUs/contactusheader.mp4";

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Poppins", system-ui;

  @media (max-width: 768px) {
    min-height: 80vh;
  }

  @media (max-width: 576px) {
    min-height: 70vh;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: -1;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  /* Dark, subtle gradient to make the blue video nodes glow and text pop */
  background: linear-gradient(
      120deg,
      rgba(2, 6, 23, 0.7), /* Very dark navy/black */
      rgba(6, 44, 63, 0.4), /* Slightly transparent mid-blue */
      rgba(2, 6, 23, 0.8)
    );
  z-index: 1;
`;

const HeaderText = styled.h1`
  font-size: 4.5rem;
  z-index: 2;
  font-family: "Poppins", system-ui;
  font-weight: 700;
  font-style: normal;
  color: #ffffff; /* Pure white text just like the image */
  margin-bottom: 0.5rem;

  span {
    color: #ffffff; /* Keeping 'Us' white to match the "Company Overview" style, change to #07b6f2 if you want it blue */
  }

  @media (max-width: 768px) {
    font-size: 3.5rem;
  }

  @media (max-width: 576px) {
    font-size: 2.5rem;
  }
`;

/* Optional: Added this to match the sub-text in your image */
const SubText = styled.p`
  z-index: 2;
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const ContactusBannerHeader = () => {
  return (
    <HeaderContainer>
      <BackgroundVideo autoPlay loop muted playsInline>
        <source src={contactusVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </BackgroundVideo>
      <Overlay />
      <HeaderText>
        Contact <span>Us</span>
      </HeaderText>
      <SubText>Accelerate Digital Transformation</SubText>
    </HeaderContainer>
  );
};

export default ContactusBannerHeader;